<template>
    <div class="task-field">
        <div class="global-label">{{ $t("Magic button settings") }}</div>

        <div class="ma-0 d-flex pt-3">
            <v-menu
                content-class="overflow-y-hidden dropmenu"
                bottom
                offset-y
                right
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="taskButtonSettings.icon"
                        outlined
                        readonly
                        hide-details
                        :label="$t('Icon')"
                        class="task-form-elem font-weight-medium pa-0 mr-3 custom-select-box"
                        v-on="on"
                        @click="openMenu"
                    >
                    </v-text-field>
                </template>

                <EmojiContainer
                    v-if="isMenuOpen"
                    @selectedEmoji="selectedEmoji"
                />
            </v-menu>

            <div class="task-field pr-3">
                <v-text-field
                    v-model="taskButtonSettings.description"
                    outlined
                    :label="$t('Title')"
                    :placeholder="$t('Title')"
                    style="font-size: 14px;"
                    :class="['task-form-elem', 'pa-0', 'font-weight-medium']"
                    :error-messages="taskButtonDescriptionError"
                ></v-text-field>
            </div>

            <div class="task-field pr-3">
                <div class="global-label">{{ $t("Visible") }}</div>
                <v-menu
                    v-model="menu_open"
                    :transition="false"
                    offset-y
                    right
                >
                    <template v-slot:activator="{ on }">
                        <div
                            tabindex="0"
                            class="disp cursor-pointer"
                            v-on="on"
                        >
                            <div
                                class="d-flex"
                                style="flex-basis: 135px;"
                            >
                                <div
                                    class="val ml-2 font-weight-medium pr-1 d-flex"
                                >
                                    {{ getVisibility().text }}
                                </div>
                                <div
                                    style="position:initial"
                                    :class="[
                                        'arrow',
                                        menu_open ? 'arrow--open' : '',
                                        'd-flex'
                                    ]"
                                >
                                    <v-icon>mdi-menu-down</v-icon>
                                </div>
                            </div>
                        </div>
                    </template>

                    <v-card>
                        <v-list
                            dense
                            style="max-height: 500px; max-width: 273px; overflow: auto;"
                        >
                            <v-list-item
                                v-for="item in visibility"
                                :key="item.value"
                                style="min-height: 32px;"
                                :disabled="!canManageAccount"
                                @click="
                                    taskButtonSettings.is_for_everyone =
                                        item.value
                                "
                            >
                                <v-list-item-content>
                                    <v-list-item-title
                                        class="font-weight-regular subtitle-2"
                                    >
                                        {{ item.text }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>
            </div>
        </div>
        <div>
            <v-checkbox
                v-model="taskButtonSettings.tracking_period"
                class="mt-0"
                true-value="month"
                :false-value="null"
                color="primary"
                hide-details
            >
                <template slot="label">
                    <span class="body-2 black--text">
                        {{ $t("Create only one task per month") }}
                    </span>
                </template>
            </v-checkbox>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import { $t } from "@/i18n";
import emojis from "@/views/Task/emojis";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import EmojiContainer from "./EmojiContainer.vue";

export default {
    components: {
        EmojiContainer
    },
    props: {
        taskButtonSettings: {
            type: Object,
            default: () => {}
        },
        taskButtonDescriptionError: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { appStoreDialogFlags } = appStoreDialog();
        const canManageAccount = ref(appStoreDialogFlags.canManageAccount());
        const menu_open = ref(false);

        function selectedEmoji(emoji) {
            props.taskButtonSettings.icon = emoji
        }

        const visibility = ref([
            { text: $t("Everyone"), value: 1 },
            { text: $t("Only me"), value: 0 }
        ]);

        const getVisibility = function() {
            return visibility.value.find(
                vis => vis.value === props.taskButtonSettings.is_for_everyone
            );
        };

        watch(
            () => props.taskButtonSettings,
            () => {
                ctx.emit("update:taskButtonSettings", props.taskButtonSettings);
            },
            { deep: true }
        );

        const isMenuOpen = ref(false);

        function openMenu() {
            isMenuOpen.value = true;
        }
        return {
            visibility,
            getVisibility,
            menu_open,
            emojis,
            canManageAccount,
            isMenuOpen,
            openMenu,
            selectedEmoji,
        };
    }
};
</script>

<style scoped lang="scss">
.emoji-picker {
    position: fixed;
    z-index: 1;
    border: 1px solid #ccc;
    width: 15rem;
    height: 20rem;
    overflow: scroll;
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: var(--v-white-base);
    box-shadow: 1px 1px 8px #c7dbe6;
    overflow-x: hidden;
}

.emoji-item {
    padding: 4px;

    &:hover {
        background: #bbbbbb;
        cursor: pointer;
    }
}

.custom-select-box {
    max-width: 45px;
}
</style>
